import flatten from 'lodash/flatten';
import { marked } from 'marked'; // eslint-disable-next-line @typescript-eslint/no-var-requires

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

const parse = require('html-react-parser'); // Issues w/ type file


const ArticleContentMarkdown = _ref => {
  let {
    children
  } = _ref;
  // marked.use(extendedTables());
  const markdown = flatten([children]).map(child => {
    var _child$props;

    if (typeof child === 'string') return child; // @ts-ignore

    const children = (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.children) || [];
    return Array.isArray(children) ? children.filter(Boolean).join('\n') : children;
  }).filter(Boolean);
  const htmlContent = markdown.map(child => marked.parse(`${child || ''}`)).join('');
  return /*#__PURE__*/_jsx(_Fragment, {
    children: parse(htmlContent)
  });
};

export default ArticleContentMarkdown;